import axios from 'axios'

const axiosInstance = axios.create({
  // Tapullo temporaneo, axios non sembra inviare l'header Authorization nella OPTIONS,
  // con conseguente blocco della richiesta dal browser
  baseURL: window.dn_products_api_url,
  withCredentials: true,
  headers: { 'X-AIC-PUBLIC': window.dn_products_app_public == 1 }, // Commentare questa riga per far girare in localhost
  /*
  auth: {
    username: 'Celiachia2019',
    password: 'NuovoSitoAICnazionale'
  }
  **/
})

export function doGet (url) {
  return axiosInstance
    .get(url)
}
